<template>
    <!-- 批量设置日期 -->
    <div class="calendar-set">
        <a-form :form="form">
            <template v-for="(k,i) in form.getFieldValue('keys')">
                <div class="date-item mb8" :key="k">
                    <div class="ml16 mb8">日期（{{i+1}} ）<a class="text-primary" v-if="form.getFieldValue('keys').length > 1" @click="deleteDate(k)">删除</a></div>
                    <a-form-item label="日期类型" required :labelCol="{span: 2}" :wrapperCol="{span: 10}">
                        <a-radio-group v-decorator="['dateLevel'+k,{initialValue:'regular'}]" >
                            <a-radio value="regular">平日</a-radio>
                            <a-radio value="peak">高峰日</a-radio>
                            <a-radio value="holiday">节假日</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="起止日期" :labelCol="{span: 2}" :wrapperCol="{span: 10}">
                        <a-range-picker v-decorator="['date'+k,{rules: [{required: true, message: '请选择起止日期'}]}]" />
                    </a-form-item>
                    <a-button @click="addDate" v-if="i === form.getFieldValue('keys').length -1" shape="round" icon="plus" class="mb16">增加日期</a-button>
                </div>
            </template>
        </a-form>
        <div class="mb16">日期类型适用门店</div>
        <div class="mt24 shop-list" v-if="shopId == -1">
            <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
                全部门店
            </a-checkbox>
            <br/>
            <a-checkbox-group v-model="checkedList" :options="shopList" @change="onChange" />
        </div>
        <div v-else>{{shopName}}</div>
        <div class="text-center mt32">
            <a-button @click="$router.go(-1)">取消</a-button>
            <a-button type="primary" @click="batchSetDate">提交</a-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            checkedList: [],
            indeterminate: false,
            checkAll: false,
            shopList: [],
            key: 0,
        }
    },
    computed: {
        ...mapGetters(["shopId","shopName"])
    },
    methods: {
        onChange(checkedList) {
            this.indeterminate = !!checkedList.length && checkedList.length < this.shopList.length;
            this.checkAll = checkedList.length === this.shopList.length;
        },
        onCheckAllChange(e) {
            let checkedList = [];
            if(e.target.checked) {
                this.shopList.forEach(item => {
                    checkedList.push(item.value)
                })
            }
            Object.assign(this, {
                checkedList: checkedList,
                indeterminate: false,
                checkAll: e.target.checked,
            });
        },
		/**
		 * @getAllShopList 获取所有门店列表
		 */
		getAllShopList() {
            this.shopList = [];
			this.$api.totalPlatform.selectList({}).then(res => {
                res.forEach(item => {
                    this.shopList.push({
                        label: item.name,
                        value: item.id
                    })
                })
			});
		},
        addDate() {
            const { form } = this;
            const keys = form.getFieldValue('keys');
            const nextKeys = keys.concat(this.key++);
            form.setFieldsValue({
                keys: nextKeys,
            });
        },
        deleteDate(k) {
            const { form } = this;
            const keys = form.getFieldValue('keys');
            if (keys.length === 1) {
                return;
            }
            form.setFieldsValue({
                keys: keys.filter(key => key !== k),
            });
        },
        batchSetDate() {
            let _this = this;
            _this.form.validateFields((err, values) => {
                if (err) return;
                if(_this.shopId == -1 && _this.checkedList.length === 0) {
                    this.$message.error('请勾选适用门店');
                    return
                }
                this.$confirm({
                    title: '是否确认提交？',
                    content: '提交后最新的日期类型将立即生效',
                    centered: true,
                    onOk() {
                            let dateRangeDtos = [];
                            values.keys.forEach(k => {
                                dateRangeDtos.push({
                                    dateLevel: values['dateLevel'+k],
                                    dateStart: values['date'+k][0].format('YYYY-MM-DD'),
                                    dateEnd: values['date'+k][1].format('YYYY-MM-DD'),
                                })
                            })
                            _this.$api.totalPlatform.batchSetDate({
                                body: {
                                    dateRangeDtos: dateRangeDtos,
                                    suitShopIdList: _this.shopId == -1 ? _this.checkedList : [_this.shopId]
                                }
                            }).then(res => {
                                _this.$message.success('操作成功');
                                _this.$router.go(-1);
                            });
                    },
                    onCancel() {},
                });
            });
        },

    },
    mounted() {
        this.getAllShopList()
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
        this.form.getFieldDecorator('keys', { initialValue: [this.key], preserve: true });
    },
    watch: {
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.calendar-set {
    background-color: #fff;
    margin: 24px;
    padding: 24px;
    .date-item {
        border-bottom: 1px solid #e9e9e9;
    }
    .shop-list {
        .ant-checkbox-wrapper {
            margin-bottom: 8px;
        }
    }
}
</style>
